export function impressionStringRefinement(data, parent) {
  // start of impression checks
  if (data.name) {
    // eslint-disable-next-line no-param-reassign
    data.name = data.name.replace(/\W+/g, '');
  }
  if (data.component) {
    // eslint-disable-next-line no-param-reassign
    data.component = data.component.replace(/\W+/g, '');
  }
  if (data.category) {
    // eslint-disable-next-line no-param-reassign
    data.category = data.category.replace(/\W+/g, '');
  }

  // start of container checks
  if (parent.name) {
    // eslint-disable-next-line no-param-reassign
    parent.name = parent.name.replace(/\W+/g, '');
  }
  if (parent.component) {
    // eslint-disable-next-line no-param-reassign
    parent.component = parent.component.replace(/\W+/g, '');
  }
  if (parent.category) {
    // eslint-disable-next-line no-param-reassign
    parent.category = parent.category.replace(/\W+/g, '');
  }
  return { data, parent };
}
